import { StoreAction, XmAction } from 'store/actions';
import { RequestStatus } from './models';

export function requestStatusReducer(state: RequestStatus, action: XmAction<RequestStatus>): RequestStatus {
    switch (action.type) {
        case StoreAction.SWITCH_PLAN:
        case StoreAction.SWITCH_PLAN_VIA_SSM_PROXY:
        case StoreAction.SWITCH_PLAN8_VIA_SSM_PROXY:
        case StoreAction.SWITCH_ACCOUNT_PLAN:
        case StoreAction.GET_REQUEST_STATUS:
        case StoreAction.POST_ALIGN_NETWORK_FEATURES:
        case StoreAction.POLL_REQUEST_STATUS:
            return action.payload;
        case StoreAction.CLEAR_ALIGN_NETWORK_FEATURES:
            return undefined;
        default:
            return state;
    }
}
